export const opportunitiesTranslations = {
  en: {
    all_cards: "All Opportunities",

    contact_message: "Hi {{name}}! I would like to contact you regarding your Opportunity for {{sport}} with a purse of {{purse}}{{currency}}.",

    my_cards: "My Opportunities",
    search_by_name: "Search by name",
    select_sport: "Select Sport",
    select_weight_class: "Select Weight Class",
    select_opportunity_type: "Select Opportunity type",
    select_purse: "Select Purse",
    select_title_match: "Select Title Match",
    reset_filters: "Reset all filters",
    create_opportunity: "Create Opportunity",
    no_opportunities_found: "No opportunities found",
    no_opportunities_description: "Try adjusting your search criteria or create a new opportunity.",
    no_sports_available: "No sports available",
    no_weight_classes_available: "No weight classes available",
    no_opportunities_available: "No Opportunities available",
    no_purse_options: "No purse options",
    opportunity_details: "Opportunity details",
    opportunity_details_subtitle: "View the complete details of this opportunity.",
    failed_to_load_opportunity_details: "Failed to load opportunity details",
    invalid_opportunity_card: "Invalid opportunity card",
    missing_sender_or_receiver: "Sender or receiver is missing",
    contact_invite_failed: "Failed to create contact invite",
    only_available_opportunity_cards_can_be_published: "Only available opportunity cards can be published",
    failed_to_publish_card: "Failed to publish opportunity card",
    not_available: "Not available",
    gender: "Gender",
    personal_details: "Personal Details",
    organization_name: "Organization Name",
    nationality: "Nationality",
    region: "Region",
    residence_country: "Residence Country",
    contact_details: "Contact Details",
    email: "Email",
    phone: "Phone",
    financial_information: "Financial Information",
    purse: "Purse",
    currency: "Currency",
    match_information: "Match Information",
    training_information: "Training Information",
    sport: "Sport",
    weight_class: "Weight Class",
    preferred_ruleset: "Level",
    opportunity_type: "Opportunity Type",
    title_match: "Title Match",
    event_details: "Event Details",
    training_details: "Training Details",
    created_at: "Created At",
    event_date: "Event Date",
    rounds: "Rounds",
    location: "Location",
    medical_support: "Medical Support",
    venue: "Venue",
    schedule: "Schedule",
    city: "City",
    country: "Country",
    total_sessions: "Total Sessions",
    duration_days: "Duration (Days)",
    additional_information: "Additional Information",
    notes: "Notes",
    additional_description: "Additional Description",
    contact: "Contact",
    contacted: "Contacted",
    expired: "Expired",
    publish: "Publish",
    published: "Published",
    publishing: "Publishing...",
    report_abuse: "Report abuse",
    reported: "Reported",
    close: "Close",
    confirm_contact: "Confirm Contact",
    confirm_contact_description: "Are you sure you want to contact the manager for this opportunity?",
    confirm_publish: "Confirm Publish",
    confirm_publish_description: "Are you sure you want to publish this opportunity?",
    confirm: "Confirm",
    manager: "Manager",
    edit: "Edit",
    delete: "Delete",
    status: "Status",
    available: "Available",
    card_published_successfully: "Card Published Successfully",
    contact_invite_success: "Contact invitation sent successfully!",
    auto_approval_hours: "Auto Approval (Hours)",
    funding_preset: "Funding Preset",
    funding_configuration: "Funding Configuration",
    base_deadline: "Base Deadline (Days Before Start)",
    variable_deadline: "Variable Deadline (Days Before Start)",
    auto_cancel_if_not_funded: "Auto Cancel If Not Funded",
    bonuses_expenses_penalties: "Bonuses/Expenses/Penalties",
    component_type: "Type",
    component_value: "Value",
    component_mode: "Mode",
    component_mandatory: "Mandatory",
    component_trigger: "Trigger",
    component_funding_stage: "Funding Stage",
    component_payment_timing: "Payment Timing",
    loading: "Loading...",
    no_data: "No data",
    document: "Document",
    download_failed: "Download failed",
    download_file: "Download {{fileName}}",
    yes: "Yes",
    no: "No",
    mandatory: "Mandatory",
    optional: "Optional",

    // NEW: generic backend enum/value -> label translations
    // Add a new lowercase key here whenever a new backend value needs a label.
    field_values: {
      upfront: "Upfront",
      split: "Split",
      fixed: "Fixed Amount",
      percent_of_base: "Percentage of Base Amount",
      pre_event: "Pre Event",
      post_event: "Post Event",
      bonus: "Bonus",
      expense: "Expense",
      penalty: "Penalty",
    },

    payout_policy: {
      baseAmount: "Base amount",
      baseLocked: "Base locked",
      baseEditable: "Base editable",
      bruto: "Bruto",
      total: "Total",
    },
    payout_outcome: {
      WIN: "Win",
      DRAW: "Draw",
      LOSS: "Loss",
      NO_SHOW_FAULT: "No-Show Fault",
      NO_SHOW_MEDICAL: "No-Show Medical",
      EVENT_CANCELLED: "Event Cancelled",
      OPPONENT_NO_SHOW: "Opponent No-Show",
    },
    payout_selection_mode: {
      BASE_PLUS_SELECTED_COMPONENTS: "Base plus selected components",
      SELECTED_COMPONENTS_ONLY: "Selected components only",
    },
    opportunity_view: {
      sections: {
        contractProgress: "Contract progress",
        coreInformation: "Core information",
        fightDetails: "Fight details",
        trainingDetails: "Training details",
        location: "Location",
        bonusesExpensesPenalties: "Bonuses, expenses & penalties",
        payoutPolicies: "Payout policies",
        documentRequirement: "Document requirement",
      },
      descriptions: {
        components: "List of all financial components displayed on the contract",
        payoutPolicies: "List of final results and payouts based on the contract outcome",
      },
      progress: {
        stages: {
          ACCEPTED: "Accepted",
          CONFIRMED: "Confirmed",
          PRE_PAYMENT: "Pre-match payment",
          EVENT: "Event",
          RESULT_UPDATED: "Result update",
          RESULT_CONFIRMED: "Result confirmation",
          POST_PAYMENT: "Post-match payment",
          FIGHTER_RATED: "Fighter rating",
          MANAGER_RATED: "Manager rating",
        },
      },
      fields: {
        opponentFighterName: "Opponent",
        paymentMode: "Payment mode",
        currency: "Currency",
        baseAmount: "Base amount",
        notes: "Deal notes",
        sport: "Sport",
        weightClass: "Weight class",
        rounds: "Number of rounds",
        roundDuration: "Round duration",
        ruleset: "Ruleset",
        eventDate: "Event date",
        isTitleFight: "Title fight",
        titleDescription: "Title description",
        medicalSupportProvided: "Medical support provided",
        medicalDocument: "Medical document",
        country: "Country",
        city: "City",
        venue: "Venue",
        venueAddress: "Venue address",
        organizationName: "Organization name",
        nationality: "Nationality",
        gender: "Gender",
        residenceCountry: "Residence country",
      },
    },
  },
  de: {
    all_cards: "Alle Möglichkeiten",
    contact_message: "Hallo {{name}}! Ich möchte Sie bezüglich Ihrer Möglichkeit für {{sport}} mit einem Preisgeld von {{purse}}{{currency}} kontaktieren.",
    my_cards: "Meine Möglichkeiten",
    search_by_name: "Nach Namen suchen",
    select_sport: "Sport auswählen",
    select_weight_class: "Gewichtsklasse auswählen",
    select_opportunity_type: "Gelegenheitstyp auswählen",
    select_purse: "Preisgeld auswählen",
    select_title_match: "Titelkampf auswählen",
    gender: "Geschlecht",
    reset_filters: "Alle Filter zurücksetzen",
    create_opportunity: "Möglichkeit erstellen",
    no_opportunities_found: "Keine Möglichkeiten gefunden",
    no_opportunities_description: "Versuchen Sie, Ihre Suchkriterien anzupassen oder eine neue Möglichkeit zu erstellen.",
    no_sports_available: "Keine Sportarten verfügbar",
    no_weight_classes_available: "Keine Gewichtsklassen verfügbar",
    no_opportunities_available: "Keine Möglichkeiten verfügbar",
    no_purse_options: "Keine Preisgeldoptionen",
    opportunity_details: "Details zur Möglichkeit",
    opportunity_details_subtitle: "Sehen Sie sich alle Details dieser Möglichkeit an.",
    failed_to_load_opportunity_details: "Details zur Möglichkeit konnten nicht geladen werden",
    invalid_opportunity_card: "Ungültige Möglichkeitskarte",
    missing_sender_or_receiver: "Absender oder Empfänger fehlt",
    contact_invite_failed: "Kontakteinladung konnte nicht erstellt werden",
    only_available_opportunity_cards_can_be_published: "Nur verfügbare Möglichkeitskarten können veröffentlicht werden",
    failed_to_publish_card: "Möglichkeitskarte konnte nicht veröffentlicht werden",
    not_available: "Nicht verfügbar",
    personal_details: "Persönliche Details",
    organization_name: "Organisationsname",
    nationality: "Nationalität",
    region: "Region",
    residence_country: "Wohnsitzland",
    contact_details: "Kontaktdetails",
    email: "E-Mail",
    phone: "Telefon",
    financial_information: "Finanzielle Informationen",
    purse: "Preisgeld",
    currency: "Währung",
    match_information: "Kampfinformationen",
    training_information: "Trainingsinformationen",
    sport: "Sport",
    weight_class: "Gewichtsklasse",
    preferred_ruleset: "Stufe",
    opportunity_type: "Gelegenheitstyp",
    title_match: "Titelkampf",
    event_details: "Veranstaltungsdetails",
    training_details: "Trainingsdetails",
    created_at: "Erstellt am",
    event_date: "Veranstaltungsdatum",
    rounds: "Runden",
    location: "Ort",
    medical_support: "Medizinische Unterstützung",
    venue: "Veranstaltungsort",
    schedule: "Zeitplan",
    city: "Stadt",
    country: "Land",
    total_sessions: "Gesamte Sessions",
    duration_days: "Dauer (Tage)",
    additional_information: "Zusätzliche Informationen",
    notes: "Notizen",
    additional_description: "Zusätzliche Beschreibung",
    contact: "Kontakt",
    contacted: "Kontaktiert",
    expired: "Abgelaufen",
    publish: "Veröffentlichen",
    published: "Veröffentlicht",
    publishing: "Veröffentlichen...",
    report_abuse: "Missbrauch melden",
    reported: "Gemeldet",
    close: "Schließen",
    confirm_contact: "Kontakt bestätigen",
    confirm_contact_description: "Sind Sie sicher, dass Sie den Manager für diese Möglichkeit kontaktieren möchten?",
    confirm_publish: "Veröffentlichung bestätigen",
    confirm_publish_description: "Sind Sie sicher, dass Sie diese Möglichkeit veröffentlichen möchten?",
    confirm: "Bestätigen",
    manager: "Manager",
    edit: "Bearbeiten",
    delete: "Löschen",
    status: "Status",
    available: "Verfügbar",
    card_published_successfully: 'Karte erfolgreich veröffentlicht',
    contact_invite_success: "Kontaktanfrage erfolgreich gesendet!",
    auto_approval_hours: "Automatische Genehmigung (Stunden)",
    funding_preset: "Finanzierungsvoreinstellung",
    funding_configuration: "Finanzierungskonfiguration",
    base_deadline: "Basisfrist (Tage vor Start)",
    variable_deadline: "Variable Frist (Tage vor Start)",
    auto_cancel_if_not_funded: "Automatisch abbrechen, wenn nicht finanziert",
    bonuses_expenses_penalties: "Boni/Ausgaben/Strafe",
    component_type: "Typ",
    component_value: "Wert",
    component_mode: "Modus",
    component_mandatory: "Obligatorisch",
    component_trigger: "Auslöser",
    component_funding_stage: "Finanzierungsstufe",
    component_payment_timing: "Zahlungszeitpunkt",
    loading: "Laden...",
    no_data: "Keine Daten",
    document: "Dokument",
    download_failed: "Download fehlgeschlagen",
    download_file: "{{fileName}} herunterladen",
    yes: "Ja",
    no: "Nein",
    mandatory: "Obligatorisch",
    optional: "Optional",

    // NEW: generic backend enum/value -> label translations
    field_values: {
      upfront: "Vorab",
      split: "Aufgeteilt",
      fixed: "Fester Betrag",
      percent_of_base: "Prozentsatz des Basisbetrags",
      pre_event: "Vor der Veranstaltung",
      post_event: "Nach der Veranstaltung",
      bonus: "Bonus",
      expense: "Ausgabe",
      penalty: "Strafe",
    },

    payout_policy: {
      baseAmount: "Basisbetrag",
      baseLocked: "Basis gesperrt",
      baseEditable: "Basis bearbeitbar",
      bruto: "Brutto",
      total: "Gesamt",
    },
    payout_outcome: {
      WIN: "Sieg",
      DRAW: "Unentschieden",
      LOSS: "Niederlage",
      NO_SHOW_FAULT: "Nicht erschienen - Verschulden",
      NO_SHOW_MEDICAL: "Nicht erschienen - medizinisch",
      EVENT_CANCELLED: "Veranstaltung abgesagt",
      OPPONENT_NO_SHOW: "Gegner nicht erschienen",
    },
    payout_selection_mode: {
      BASE_PLUS_SELECTED_COMPONENTS: "Basis plus ausgewahlte Komponenten",
      SELECTED_COMPONENTS_ONLY: "Nur ausgewahlte Komponenten",
    },
    opportunity_view: {
      sections: {
        contractProgress: "Vertragsfortschritt",
        coreInformation: "Grundinformationen",
        fightDetails: "Kampfdetails",
        trainingDetails: "Trainingsdetails",
        location: "Ort",
        bonusesExpensesPenalties: "Boni, Ausgaben & Strafen",
        payoutPolicies: "Auszahlungsrichtlinien",
        documentRequirement: "Dokumentenanforderung",
      },
      descriptions: {
        components: "Liste aller im Vertrag aufgeführten finanziellen Komponenten",
        payoutPolicies: "Liste der Endergebnisse und Auszahlungen je nach Vertragsergebnis",
      },
      progress: {
        stages: {
          ACCEPTED: "Angenommen",
          CONFIRMED: "Bestätigt",
          PRE_PAYMENT: "Vorab-Zahlung",
          EVENT: "Event",
          RESULT_UPDATED: "Ergebnis-Update",
          RESULT_CONFIRMED: "Ergebnisbestätigung",
          POST_PAYMENT: "Nachkampf-Zahlung",
          FIGHTER_RATED: "Kämpferbewertung",
          MANAGER_RATED: "Managerbewertung",
        },
      },
      fields: {
        opponentFighterName: "Gegner",
        paymentMode: "Zahlungsart",
        currency: "Währung",
        baseAmount: "Grundbetrag",
        notes: "Notizen zum Deal",
        sport: "Sportart",
        weightClass: "Gewichtsklasse",
        rounds: "Anzahl der Runden",
        roundDuration: "Rundendauer",
        ruleset: "Regelwerk",
        eventDate: "Veranstaltungsdatum",
        isTitleFight: "Titelkampf",
        titleDescription: "Titelbeschreibung",
        medicalSupportProvided: "Medizinische Unterstützung bereitgestellt",
        medicalDocument: "Medizinisches Dokument",
        country: "Land",
        city: "Stadt",
        venue: "Austragungsort",
        venueAddress: "Adresse des Austragungsorts",
        organizationName: "Organisationsname",
        nationality: "Nationalität",
        gender: "Geschlecht",
        residenceCountry: "Wohnsitzland",
      },
    },
  },
  hr: {
    contact_invite_success: "Poziv za kontakt je uspješno poslan!",

    all_cards: "Sve prilike",
    my_cards: "Moje prilike",
    search_by_name: "Pretraži po imenu",
    select_sport: "Odaberi sport",
    select_weight_class: "Odaberi težinsku kategoriju",
    select_opportunity_type: "Odaberi vrstu prilike",
    select_purse: "Odaberi nagradni fond",
    select_title_match: "Odaberi naslovni meč",
    reset_filters: "Poništi sve filtre",
    create_opportunity: "Stvori priliku",
    no_opportunities_found: "Nema pronađenih prilika",
    no_opportunities_description: "Pokušajte prilagoditi kriterije pretraživanja ili stvoriti novu priliku.",
    no_sports_available: "Nema dostupnih sportova",
    no_weight_classes_available: "Nema dostupnih težinskih kategorija",
    no_opportunities_available: "Nema dostupnih prilika",
    no_purse_options: "Nema opcija za nagradni fond",
    opportunity_details: "Detalji prilike",
    opportunity_details_subtitle: "Pogledajte sve detalje ove prilike.",
    failed_to_load_opportunity_details: "Učitavanje detalja prilike nije uspjelo",
    invalid_opportunity_card: "Nevažeća kartica prilike",
    missing_sender_or_receiver: "Nedostaje pošiljatelj ili primatelj",
    contact_invite_failed: "Izrada pozivnice za kontakt nije uspjela",
    only_available_opportunity_cards_can_be_published: "Mogu se objaviti samo dostupne kartice prilika",
    failed_to_publish_card: "Objava kartice prilike nije uspjela",
    not_available: "Nije dostupno",
    personal_details: "Osobni podaci",
    organization_name: "Naziv organizacije",
    nationality: "Nacionalnost",
    region: "Regija",
    residence_country: "Država prebivališta",
    contact_details: "Kontakt podaci",
    email: "E-mail",
    phone: "Telefon",
    financial_information: "Financijske informacije",
    purse: "Nagradni fond",
    currency: "Valuta",
    match_information: "Informacije o meču",
    sport: "Sport",
    weight_class: "Težinska kategorija",
    preferred_ruleset: "Razina",
    opportunity_type: "Vrsta prilike",
    title_match: "Naslovni meč",
    event_details: "Detalji događaja",
    created_at: "Kreirano",
    event_date: "Datum događaja",
    rounds: "Runde",
    gender: "Spol",
    location: "Lokacija",
    medical_support: "Medicinska podrška",
    venue: "Mjesto",
    schedule: "Raspored",
    city: "Grad",
    country: "Država",
    total_sessions: "Ukupno sesija",
    duration_days: "Trajanje (dani)",
    training_information: "Informacije o treningu",
    training_details: "Detalji treninga",
    notes: "Bilješke",
    additional_description: "Dodatni opis",
    contact: "Kontakt",
    contacted: "Kontaktiran",
    expired: "Istekao",
    publish: "Objavi",
    published: "Objavljeno",
    publishing: "Objavljivanje...",
    report_abuse: "Prijavi zloupotrebu",
    reported: "Prijavljeno",
    close: "Zatvori",
    confirm_contact: "Potvrdi kontakt",
    confirm_contact_description: "Jeste li sigurni da želite kontaktirati menadžera za ovu priliku?",
    confirm_publish: "Potvrdi objavu",
    confirm_publish_description: "Jeste li sigurni da želite objaviti ovu priliku?",
    confirm: "Potvrdi",
    manager: "Menadžer",
    edit: "Uredi",
    delete: "Izbriši",
    status: "Status",
    card_published_successfully: 'Kartica je uspješno objavljena',
    available: "Dostupno",
    contact_message: "Bok {{name}}! Želio/Željela bih vas kontaktirati u vezi vaše prilike za {{sport}} s nagradnim fondom od {{purse}}{{currency}}.",
    auto_approval_hours: "Automatsko odobrenje (sati)",
    funding_preset: "Predložak financiranja",
    funding_configuration: "Konfiguracija financiranja",
    base_deadline: "Osnovni rok (dani prije početka)",
    variable_deadline: "Varijabilni rok (dani prije početka)",
    auto_cancel_if_not_funded: "Automatski otkaži ako nije financirano",
    bonuses_expenses_penalties: "Bonusi/Troškovi/Kazne",
    component_type: "Vrsta",
    component_value: "Vrijednost",
    component_mode: "Način",
    component_mandatory: "Obavezno",
    component_trigger: "Okidač",
    component_funding_stage: "Faza financiranja",
    component_payment_timing: "Vrijeme plaćanja",
    loading: "Učitavanje...",
    no_data: "Nema podataka",
    document: "Dokument",
    download_failed: "Preuzimanje nije uspjelo",
    download_file: "Preuzmi {{fileName}}",
    yes: "Da",
    no: "Ne",
    mandatory: "Obavezno",
    optional: "Neobavezno",

    // NEW: generic backend enum/value -> label translations
    field_values: {
      upfront: "Unaprijed",
      split: "Podijeljeno",
      fixed: "Fiksni iznos",
      percent_of_base: "Postotak osnovnog iznosa",
      pre_event: "Prije događaja",
      post_event: "Nakon događaja",
      bonus: "Bonus",
      expense: "Trošak",
      penalty: "Kazna",
    },

    payout_policy: {
      baseAmount: "Osnovni iznos",
      baseLocked: "Osnovica zaključana",
      baseEditable: "Osnovica se može urediti",
      bruto: "Bruto",
      total: "Ukupno",
    },
    payout_outcome: {
      WIN: "Pobjeda",
      DRAW: "Neriješeno",
      LOSS: "Poraz",
      NO_SHOW_FAULT: "Nedolazak - krivnja",
      NO_SHOW_MEDICAL: "Nedolazak - medicinski",
      EVENT_CANCELLED: "Događaj otkazan",
      OPPONENT_NO_SHOW: "Protivnik se nije pojavio",
    },
    payout_selection_mode: {
      BASE_PLUS_SELECTED_COMPONENTS: "Osnovica + odabrane komponente",
      SELECTED_COMPONENTS_ONLY: "Samo odabrane komponente",
    },
    opportunity_view: {
      sections: {
        contractProgress: "Napredak ugovora",
        coreInformation: "Osnovne informacije",
        fightDetails: "Detalji borbe",
        trainingDetails: "Detalji treninga",
        location: "Lokacija",
        bonusesExpensesPenalties: "Bonusi, troškovi i kazne",
        payoutPolicies: "Pravila isplate",
        documentRequirement: "Zahtjev za dokumentom",
      },
      descriptions: {
        components: "Popis svih financijskih komponenti prikazanih u ugovoru",
        payoutPolicies: "Popis konačnih rezultata i isplata prema ishodu ugovora",
      },
      progress: {
        stages: {
          ACCEPTED: "Prihvaćeno",
          CONFIRMED: "Potvrđeno",
          PRE_PAYMENT: "Uplata prije borbe",
          EVENT: "Događaj",
          RESULT_UPDATED: "Ažuriranje rezultata",
          RESULT_CONFIRMED: "Potvrda rezultata",
          POST_PAYMENT: "Uplata nakon borbe",
          FIGHTER_RATED: "Ocjena borca",
          MANAGER_RATED: "Ocjena menadžera",
        },
      },
      fields: {
        opponentFighterName: "Protivnik",
        paymentMode: "Način plaćanja",
        currency: "Valuta",
        baseAmount: "Osnovni iznos",
        notes: "Bilješke o dogovoru",
        sport: "Sport",
        weightClass: "Težinska kategorija",
        rounds: "Broj rundi",
        roundDuration: "Trajanje runde",
        ruleset: "Pravila",
        eventDate: "Datum događaja",
        isTitleFight: "Borba za naslov",
        titleDescription: "Opis naslova",
        medicalSupportProvided: "Osigurana medicinska podrška",
        medicalDocument: "Medicinski dokument",
        country: "Država",
        city: "Grad",
        venue: "Mjesto održavanja",
        venueAddress: "Adresa mjesta održavanja",
        organizationName: "Naziv organizacije",
        nationality: "Nacionalnost",
        gender: "Spol",
        residenceCountry: "Država prebivališta",
      },
    },
  }
};